import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from './core/services/auth.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ServerInterceptor } from './core/interceptor/server.interceptor';
import { UserManagerService } from './pages/user-manager/user-manager.service';
import { DeviceManagerService } from './pages/device-manager/device-manager.service';
import { FirmwareManagerService } from './pages/firmware-manager/firmware-manager.service';
import { SsoModule } from './sso/sso.module';
import { ProfileService } from './pages/profile/profile.service';
import { SiderService } from './core/services/sider.service';
import { TranslateModule } from '@ngx-translate/core';
import { ToastService } from './core/services/toast.service';
import { WordpressService } from './core/services/wordpress.service';
import { BindService } from './core/services/bind.service';
import { FormsModule } from '@angular/forms';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { zh_CN } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';

registerLocaleData(zh);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SsoModule,
    TranslateModule.forRoot(),
    FormsModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ServerInterceptor, multi: true },
    AuthService,
    SiderService,
    UserManagerService,
    DeviceManagerService,
    FirmwareManagerService,
    ProfileService,
    ToastService,
    WordpressService,
    BindService,
    { provide: NZ_I18N, useValue: zh_CN }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
